module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "total"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "total-head"
  }, [_c('span', {
    staticClass: "title"
  }, [(_vm.type === 1) ? _c('span', [_c('i', {
    staticClass: "icon-sousuo"
  }), _vm._v("大家在找")]) : (_vm.type === 2) ? _c('span', [_c('i', {
    staticClass: "icon-baokuanresou"
  }), _vm._v("新增热搜")]) : (_vm.type === 3) ? _c('span', [_c('i', {
    staticClass: "icon-ruzhu"
  }), _vm._v("最新入驻")]) : (_vm.type === 4) ? _c('span', [_c('i', {
    staticClass: "icon-gongying"
  }), _vm._v("供应求购")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "fr more",
    on: {
      "click": _vm.clickMth
    }
  }, [_vm._v("查看更多"), _c('i', {
    staticClass: "icon-gengduo"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "total-title"
  }, [_c('div', {
    staticClass: "total-title-small"
  }), _vm._v(" "), _c('div', {
    staticClass: "total-title-big"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-25ddc2d1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/homePageLists/rollComponents/totalTitle.vue
// module id = 807
// module chunks = 39